<div class="card">
    <a id="show-more-link" class="dropdown-link" (click)="getMoreListings()">Weitere Anzeigen laden<span class="sd-icon">angle_down</span></a>
</div>
